import { render, staticRenderFns } from "./suggestionEntryCardHeader.vue.html?vue&type=template&id=aeccf0b4&"
import script from "./suggestionEntryCardHeader.ts?vue&type=script&lang=ts&"
export * from "./suggestionEntryCardHeader.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports